import { ServiceType, formatServiceTypePlural } from '@bookpeazy/common-js';
import React, { useState } from 'react';

type ServiceCardProps = {
  serviceType: ServiceType;
  onClick: (serviceType: ServiceType) => void;
  isSelected: boolean;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  serviceType,
  onClick,
  isSelected,
}) => (
  <div
    className={`p-4 border rounded-lg shadow-md hover:bg-gray-100 cursor-pointer ${isSelected ? 'border border-solid border-primary' : ''}`}
    onClick={() => onClick(serviceType)}
    data-cy={`service-card-${serviceType}`}
  >
    <div>{formatServiceTypePlural(serviceType)}</div>
  </div>
);

type ServiceTypeCardGridProps = {
  onServiceClick: (serviceType: ServiceType) => void;
  types: ServiceType[];
  value: ServiceType | null;
}

const ServiceTypeCardGrid: React.FC<ServiceTypeCardGridProps> = ({
  onServiceClick,
  types,
  value,
}) => {
  const [filter, setFilter] = useState('');

  const filteredServices = types.filter(serviceType =>
    formatServiceTypePlural(serviceType).toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Filter services..."
        className="mb-4 p-2 border rounded w-full"
        value={filter}
        onChange={e => setFilter(e.target.value)}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {filteredServices.map(serviceType => (
          <ServiceCard
            key={serviceType}
            serviceType={serviceType}
            onClick={onServiceClick}
            isSelected={serviceType === value}
          />
        ))}
      </div>
    </div>
  );
};

export default ServiceTypeCardGrid;

